import React, { useState } from "react";
import SelectAppModal from "../../../common-components/ManagementToolSelection";
import JiraSelectionPage from "../jira-connection/JiraSelectionPage";
import ADOSelectionPage from "../ado-connection/ADOSelectionPage";
import TestRailSelectionPage from "../testrail-connection/testrailSelectionPage";
import QTestSelectionPages from "../qtest-connection/QTestSelectionPages";
import ADOExportPage from "../ado-connection/ADOExportPage";
import ConfluenceSelectionPage from "../confluence-connection/ConfluenceSelectionsPage";
import { JiraExport } from "../jira-connection/JiraExport";
import ConfluenceImportPage from "../confluence-connection/ConfluenceImportPage";
// import QTestBugExportPage from "../qtest-connection/QTestBugExportPage";

const ALMConnectionPage = ({
  issueType,
  setPageCloser,
  testCasesData,
  taskType = "Import",
  almConfig,
  setALMConfig,
  inputData,
  bugsData,
  exportData,
  confluenceConfig,
}) => {
  const [selectedAPP, setSelectedApp] = useState(null);
  const [proceedingApp, setProceedingApp] = useState(null);

  return (
    <div>
      {!proceedingApp && (
        <SelectAppModal
          setPageCloser={setPageCloser}
          selectedApp={selectedAPP}
          setSelectedApp={setSelectedApp}
          proceedingApp={proceedingApp}
          setProceeedingApp={setProceedingApp}
          issueType={issueType}
          taskType={taskType} 
        />
      )}

      {proceedingApp === "Jira" && taskType === "Import" && (
        <JiraSelectionPage
          issueType={issueType}
          setJiraPageOpen={setPageCloser}
        />
      )}

      {proceedingApp === "Jira" && taskType === "Export" && (
        <JiraExport
          taskType={taskType}
          issueType={issueType}
          setJiraPageOpen={setPageCloser}
          exportData={exportData}
          almConfig={almConfig}
        />
      )}

      {proceedingApp === "Azure" && taskType === "Import" && (
        <ADOSelectionPage
          issueType={issueType}
          setADOPageOpen={setPageCloser}
        />
      )}

      {proceedingApp === "Azure" && taskType === "Export" && (
        <ADOExportPage
          taskType={taskType}
          issueType={issueType}
          setADOPageOpen={setPageCloser}
          exportData={exportData}
          almConfig={almConfig}
        />
      )}

      {proceedingApp === "TestRail" && taskType === "Export" && (
        <TestRailSelectionPage
          taskType={taskType}
          issueType={issueType}
          setTestRailPageOpen={setPageCloser}
          testCasesData={testCasesData}
        />
      )}

      {proceedingApp === "Confluence" && taskType === "Import" && (
        <ConfluenceImportPage
          issueType={issueType}
          setConfluencePageOpen={setPageCloser}
          setProceedingApp={setProceedingApp}
        />
      )}

      {proceedingApp === "Confluence" && taskType === "Export" && (
        <ConfluenceSelectionPage
          taskType={taskType}
          issueType={issueType}
          setConfluencePageOpen={setPageCloser}
          exportData={exportData}
          confluenceConfig={confluenceConfig}
          setProceedingApp={setProceedingApp}
        />
      )}

      {proceedingApp === "qTest" && taskType === "Export" && issueType === "Test Cases" && (
        <QTestSelectionPages
          taskType={taskType}
          issueType={issueType}
          setQTestSelectionPageOpen={setPageCloser}
          testCasesData={testCasesData}
          almConfig={almConfig}
        />
      )}

      {/* {proceedingApp === "qTest" && taskType === "Export" && issueType === "Bugs" && (
        <QTestBugExportPage
          taskType={taskType}
          issueType={issueType}
          setQTestPageOpen={setPageCloser}
          exportData={exportData}
        />
      )} */}
    </div>
  );
};

export default ALMConnectionPage;